"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersErrorWrapper = exports.TwapErrorWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_error_boundary_1 = require("react-error-boundary");
var analytics_1 = require("./analytics");
var FallbackUI = function () {
    return (0, jsx_runtime_1.jsx)("div", { children: "Something went wrong" });
};
function TwapErrorWrapper(_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)(react_error_boundary_1.ErrorBoundary, __assign({ onError: function (error) {
            analytics_1.analytics.uiCrashed("twap", error);
            // You can also log the error to an error reporting service like AppSignal
            // logErrorToMyService(error, errorInfo);
            console.error(error);
        }, FallbackComponent: FallbackUI }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) })));
}
exports.TwapErrorWrapper = TwapErrorWrapper;
function OrdersErrorWrapper(_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)(react_error_boundary_1.ErrorBoundary, __assign({ onError: function (error) {
            analytics_1.analytics.uiCrashed("orders", error);
        }, fallbackRender: function () { return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}); } }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) })));
}
exports.OrdersErrorWrapper = OrdersErrorWrapper;
